export const CONST_NOTIFY = {
  MESSAGE_TYPE: {
    SUCCESS: 'good',
    WARNING: 'warning',
    ERROR: 'strong',
  },
};
